export default __webpack_public_path__ + "static/media/appSwitch.423da02c.svg";